import RequestRole from 'components/RequestRole/RequestRole.vue' 
import ActiveRolesList from 'components/ActiveRolesList/ActiveRolesList.vue' 

export default {
    name: "RolesFormContent",
    components: {
        RequestRole,
        ActiveRolesList
    },
    setup(){
        
    }
}